import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function GuideSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-charcoal-dark relative border-t border-white/5" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-charcoal border border-gold/30 rounded-3xl p-8 sm:p-12 relative overflow-hidden shadow-[0_0_40px_rgba(212,168,83,0.1)]" data-id="element-125">
          <div className="absolute top-0 right-0 w-64 h-64 bg-gold/10 blur-[80px] rounded-full pointer-events-none" data-id="element-126" />

          <div className="text-center mb-10" data-id="element-127">
            <h2 className="text-4xl md:text-5xl font-bold mb-2" data-id="element-128">
              ¿Quién te{' '}
              <span className="text-gold italic font-normal" data-id="element-129">guía?</span>
            </h2>
          </div>

          <div className="flex flex-col md:flex-row gap-10 items-center md:items-start relative z-10" data-id="element-130">
            <div className="flex-shrink-0" data-id="element-131">
              <div className="w-48 h-48 rounded-full border-4 border-gold/30 overflow-hidden relative shadow-lg" data-id="element-132">
                <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&q=80&auto=format&fit=crop" alt="Catalina Suárez" className="w-full h-full object-cover" data-id="element-133" />
              </div>
            </div>

            <div className="flex-1 text-center md:text-left" data-id="element-134">
              <p className="text-xl text-cream-muted leading-relaxed mb-8 font-serif italic" data-id="element-135">
                "Soy Catalina, mamá de dos nenas. Empecé desde mi casa sin
                experiencia. En mi primer mes ya estaba vendiendo por WhatsApp.
                Hoy tengo clientes, pedidos constantes y enseño este sistema."
              </p>

              <ul className="space-y-3 inline-flex flex-col items-start" data-id="element-136">
                {['+200 alumnas', 'Método probado', 'Resultados reales'].map((item, i) => <li key={i} className="flex items-center gap-3 text-lg font-medium text-gold-light" data-id="element-137">
                      <CheckCircle2 className="w-6 h-6 text-gold" data-id="element-138" />
                      {item}
                    </li>)}
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}